<footer class="footer bg-grey-light-4 py-3 text-grey text-sm">
  <div class="container">
    <ul
      *ngIf="checkoutFooter?.links"
      class="col-span-12 col-count-2 md:inline-flex md:col-span-6 lg:col-span-8 md:col-count-auto md:ml-auto md:order-1"
    >
      <li *ngFor="let link of checkoutFooter.links; let isFirst = first">
        <a
          [href]="link.link"
          class="block py-2 hover:underline"
          [class.md:ml-4]="!isFirst"
          [target]="link.target"
          [rel]="'noopener noreferrer'"
        >
          {{ link.title }}
        </a>
      </li>
    </ul>

    <app-divider class="col-span-12 md:hidden" color="white"></app-divider>

    <div class="col-span-12 flex items-center md:col-span-6 lg:col-span-4">
      <app-logo
        class="mr-2"
        [height]="25"
        [alt]="'checkout.footer.logo' | translate"
      ></app-logo>
      <p>{{ 'checkout.footer.rights' | translate }}</p>
    </div>
  </div>
</footer>
